import React from 'react';

interface FireyEffectProps {
  isActive: boolean;
  className?: string;
}

export const FireyEffect: React.FC<FireyEffectProps> = ({ isActive, className = '' }) => {
  if (!isActive) return null;

  return (
    <div className={`absolute inset-0 pointer-events-none rounded-full animate-fire-glow ${className}`} />
  );
};

// CSS for fire glow animation using box-shadow with theme colors
export const FireyEffectCSS = `
@keyframes fire-glow {
  0% {
    box-shadow: 
      0 0 6px rgba(6, 182, 212, 0.2),
      2px -2px 8px rgba(16, 185, 129, 0.15),
      -4px -4px 10px rgba(37, 99, 235, 0.15),
      4px -8px 12px rgba(5, 150, 105, 0.1),
      -4px -12px 15px rgba(29, 78, 216, 0.1),
      0 -16px 18px rgba(8, 145, 178, 0.08),
      2px -18px 20px rgba(6, 95, 70, 0.05);
  }
  100% {
    box-shadow: 
      0 0 8px rgba(6, 182, 212, 0.3),
      3px -3px 10px rgba(6, 182, 212, 0.2),
      -5px -5px 12px rgba(16, 185, 129, 0.2),
      5px -10px 15px rgba(37, 99, 235, 0.15),
      -5px -14px 18px rgba(5, 150, 105, 0.15),
      0 -18px 20px rgba(29, 78, 216, 0.1),
      3px -20px 22px rgba(8, 145, 178, 0.08);
  }
}

.animate-fire-glow {
  animation: fire-glow 1s ease-in-out infinite alternate;
}
`;